import { CookSubscriptionV3Interface } from "../interfaces/CookSubscriptionV3Interfaces/CookSubscriptionV3Interface";
import { CreateCookSubscriptionV3interface } from "../interfaces/CookSubscriptionV3Interfaces/CreateCookSubscriptionV3Interface";
import BaseService from "./BaseService";

export class CookSubscriptionV3Service extends BaseService<CookSubscriptionV3Interface, CreateCookSubscriptionV3interface>{ 
    constructor(){
        let url: string = '/cook-subscription/v3/admin'
        super(url)
    }
}